// URL base da API por ambiente.
//
// Definida em BUILD TIME pelo Cloudflare Pages (variavel de ambiente por ambiente:
// Production / Preview) com o nome REACT_APP_API_URL - o CRA injeta apenas variaveis
// com o prefixo REACT_APP_ via DefinePlugin, entao o nome importa.
//
// O fallback mantem producao funcionando se a variavel nao estiver definida.
const API_URL =
  process.env.REACT_APP_API_URL || "https://chat-api.dsploadout.com/v1/";

export default API_URL;
